module.exports = __webpack_public_path__ + "img/partners44.e432b970.svg";